import useSWR, { type SWRConfiguration } from "swr";
import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import { config } from "@/config";
import type { CollarsGeoJsonResponse } from "./type";

async function getCollarsGeoJson(
  query?: string,
): Promise<CollarsGeoJsonResponse> {
  const params = new URLSearchParams();

  if (query) {
    params.append("number", query);
  }

  const url = `${apiPaths.devices.collars.getGeoJson}?${params.toString()}`;
  const response = await apiClient.get<CollarsGeoJsonResponse>(url);

  return response.data;
}

export function useGetCollarsGeoJson(
  query?: string,
  options?: SWRConfiguration & { enabled?: boolean },
) {
  const enabled = options?.enabled ?? true;

  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    enabled ? `fetch-collars-geojson:${JSON.stringify(query ?? {})}` : null,
    () => getCollarsGeoJson(query),
    mergedOptions,
  );
}
